export const siteSettings = {
  name: "Finex Sphere",
  link: "https://finexspherepro.com",
  email: "support@finexspherepro.com",
  appLink: "https://app.finexspherepro.com",
};
